import Link from 'next/link';
import React from 'react';

import {Image} from '@udemy/react-core-components';

import styles from '../api-clients.module.less';

const BOX_ICONS = [
    `${process.env.DEPLOY_BASE_PATH}/staticx/udemy/images/dev-portal/productivity.png`,
    `${process.env.DEPLOY_BASE_PATH}/staticx/udemy/images/dev-portal/it.png`,
    `${process.env.DEPLOY_BASE_PATH}/staticx/udemy/images/dev-portal/personal-dev.png`,
    `${process.env.DEPLOY_BASE_PATH}/staticx/udemy/images/dev-portal/development.png`,
];

interface ApiClientBoxProps {
    title: string;
    clientId: string;
    // Used to display box icon
    boxIndex: number;
}
export const ApiClientBox = ({title, clientId, boxIndex}: ApiClientBoxProps) => {
    return (
        <div className={styles['client-box']}>
            <Image
                alt={title}
                src={BOX_ICONS[boxIndex % BOX_ICONS.length]}
                width={80}
                height={80}
            />
            <h3 className="ud-heading-lg">{title}</h3>
            <Link href={`${process.env.DEPLOY_BASE_PATH}/api-clients/${clientId}/`}>See more</Link>
        </div>
    );
};
